import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListServicesRatingByServices = `${host}admin/exportJSON/serviceRating`

export const getListServicesRatingByServices = ({
    FromDate,
    ToDate,
    BranchIDs,
    Rating,
    ServiceCode,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        Rating,
        ServiceCode,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByServices,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_SERVICES_RATING_BY_SERVICE,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    Rating,
                    ServiceCode,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_SERVICES_RATING_BY_SERVICE_ERROR,
            () => false
        )
    }
}

export const exportListServicesRatingByServices = ({
    FromDate,
    ToDate,
    BranchIDs,
    Rating,
    ServiceCode,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        Rating,
        ServiceCode,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByServices,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
